'use client'

import { InfoCircle24 } from '@vinted/monochrome-icons'
import { Button } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useConversationDetailsNavigator } from '@marketplace-web/messaging/navigation-feature'

type Props = {
  conversationId: string
}

const ConversationHeaderRightAction = ({ conversationId }: Props) => {
  const translate = useTranslate()

  const conversationDetailsNavigator = useConversationDetailsNavigator()

  return (
    <Button
      styling="flat"
      theme="amplified"
      inline
      iconName={InfoCircle24}
      testId="details-button"
      onClick={() => conversationDetailsNavigator.navigate(conversationId)}
      aria={{ 'aria-label': translate('inbox.a11y.information') }}
    />
  )
}

export default ConversationHeaderRightAction
